import React from 'react';

interface StepContainerProps {
  title: string;
  children: React.ReactNode;
}

export const StepContainer: React.FC<StepContainerProps> = ({ title, children }) => {
  return (
    <div className="step-content">
      <h1>{title}</h1>
      {children}
    </div>
  );
};